import { log, supabase } from ".";

export const getEdificios = async ({ pais }) => {
  try {
    const data = await supabase.select("edificios", {
      filters: { pais },
      orderBy: [
        { column: "estado", ascending: true },
        { column: "pantallas", ascending: false },
      ],
    });

    if (data?.length === 0) {
      // Removed toast.error to prevent UI notification
      return []; // Return empty array instead of throwing error
    }

    return data;
  } catch (error) {
    log.error("getEdificios", error);
    throw error; // Throw only for other errors (e.g., network issues)
  }
};
